<template>

    <div class="mb-3">

        <label v-if="label" class="form-label" :for="id">
            {{ translatedLabel }}
            <span v-if="help">
                <i class="bi bi-question-circle" :title="help"></i>
            </span>
        </label>

        <!--@todo multiple files!-->
        <input 
            :id="id"
            ref="file" 
            v-bind="$attrs"
            class="form-control form-control-lg" 
            :class="{ 'is-invalid': error }" 
            :placeholder="translatedLabel" 
            type="file" 
            @change="change" />

        <progress class="w-100" v-if="form.progress" :value="form.progress.percentage" max="100">
            {{ form.progress.percentage }}%
        </progress>

        <div v-if="value">
            <div v-if="url" class="mt-3">
                <img :src="url" alt="" class="img-fluid" style="max-height: 150px;" />
            </div>
            <div class="mt-3">
                {{ value.size | humanReadableFilesize }}
            </div>
            <div class="mt-3">
                <button type="button" class="btn btn-sm btn-outline-danger" @click="remove">
                    {{ __('Entfernen') }}
                </button>
            </div>
        </div>

        <div v-if="error" class="invalid-feedback">{{ error }}</div>

        <!--        <div class="form-input p-0" :class="{ error: errors.length }">
                    <div v-if="!value" class="p-2">
                        <button type="button" class="px-4 py-1 bg-gray-500 hover:bg-gray-700 rounded-sm text-xs font-medium text-white" @click="browse">
                            Browse
                        </button>
                    </div>
                    <div v-else class="flex items-center justify-between p-2">
                        <div class="flex-1 pr-1">
                            {{ value.name }} <span class="text-gray-500 text-xs">({{ value.size | humanReadableFilesize }})</span>
                        </div>
                        <button type="button" class="px-4 py-1 bg-gray-500 hover:bg-gray-700 rounded-sm text-xs font-medium text-white" @click="remove">
                            Remove
                        </button>
                    </div>
                </div>-->
    </div>

</template>

<script>
    export default {
        props: {
            id: {
                type: String,
                default() {
                    return `file-input-${this._uid}`
                },
            },
            form: Object,
            value: File,
            label: String,
            error: String,
            help: String,

        },
        data() {
            return {
                url: null,
            }
        },
        watch: {
            value(value) {
                if (!value) {
                    this.$refs.file.value = '';
                }
            },
        },
        computed: {
            translatedLabel() {
                return this.langHas('validation.attributes.' + this.label)
                        ? this.__('validation.attributes.' + this.label)
                        : this.label;
            }
        },
        methods: {
            change(e) {
                const file = e.target.files[0];
                this.url = URL.createObjectURL(file);

                this.$emit('input', file);
            },
            remove() {
                this.$emit('input', null);
            },
        },
    }
</script>